export const getValue = (value: any) => {
  if (Array.isArray(value)) {
    if (value.length < 1) {
      return window.Alfresco.messages.global['label.none'];
    }

    return value[0].label ? value.map(item => item.label).join(', ') : value.join(', ');
  }

  if (!value) return window.Alfresco.messages.global['label.none'];

  if (value.constructor && value.constructor.name === 'Object') {
    return value.label ? value.label : window.Alfresco.messages.global['label.none'];
  }
  return value;
};

export const countTitles = (data: any) =>
  data.reduce((acc: any, next: any) => {
    const title = next.values['prop_cm_title'].value;
    return {
      ...acc,
      [title]: acc[title] ? acc[title] + 1 : 1,
    };
  }, {});

export const remapField = (field: any, secondaryText: string, label: string = '') => ({
  //Remap object keys from 'prop_' to ':' form, values from object to its value.
  ...Object.keys(field.values).reduce(
    (acc, next) => ({ ...acc, [next.split('_').slice(1).join(':')]: field.values[next]?.value || '' }),
    {}
  ),
  secondaryText: secondaryText,
  label: label,
  value: field.nodeRef,
});
